import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@headlessui/react";
import SourceIQLogo from "../UILibrary/SourceIQLogo";
import { useNavigate } from "react-router-dom";
// import gsap from "gsap";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  // const scrollToSection = (id) => {
  //   const section = document.getElementById(id);
  //   if (section) {
  //     gsap.to(window, {
  //       scrollTo: {
  //         y: section,
  //         offsetY: 60,
  //       },
  //       duration: 2,
  //       ease: "power2.inOut",
  //     });
  //   }
  // };
  const handleLinkClick = (page) => {
    console.log(page);
    switch (page) {
      case "about":
        navigate("/about");
        break;
      case "overview":
        navigate("/");
        break;
      default:
        break;
    }
  };

  return (
    <header
      className="fixed top-0 left-0 w-full z-[9999] bg-white shadow-md"
      style={{ zIndex: 9999 }}
    >
      <div className="w-full px-4 sm:px-6 lg:px-8 mx-auto">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div
            className="flex items-center gap-2 cursor-pointer"
            onClick={() => navigate("/")}
          >
            <SourceIQLogo fill="black" width={120} height={19} />
            <nav className="hidden md:flex items-start gap-8 ml-6">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleLinkClick("about");
                }}
                className="text-[#1D2739] hover:text-gray-600 transition font-medium text-[18px]"
              >
                About
              </button>

              {/* <a
                href="#pricing"
                className="text-[#1D2739] hover:text-gray-600 transition font-medium text-[18px]"
              >
                Pricing
              </a>
              <button
                onClick={() => handleLinkClick("overview")}
                className="text-[#1D2739] hover:text-gray-600 transition font-medium text-[18px]"
              >
                Overview
              </button> */}
            </nav> 
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex gap-6 items-center">
            <Button
              onClick={() => navigate("/login")}
              className="text-black font-normal text-base rounded border px-4 py-2 hover:text-gray-600 transition bg-white"
            >
              Sign In
            </Button>
            <Button
              onClick={() => navigate("/signup")}
              className="text-white text-base rounded px-4 py-2 hover:opacity-90 transition bg-[#0088FF]"
            >
              Get Started
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-black"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="md:hidden fixed top-16 left-0 w-full h-[calc(100vh-4rem)] bg-white border-t border-gray-200 shadow-lg py-6 px-6 z-40">
           <nav className="flex flex-col space-y-4 text-left mb-4">
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleLinkClick("about");
              }}
              className="block text-gray-800 text-lg font-medium hover:text-blue-600 transition text-left"
            >
              About
            </button>
            {/* <a
              href="#pricing"
              className="block text-gray-800 text-lg font-medium hover:text-blue-600 transition text-left"
            >
              Pricing
            </a>
            <button
                  onClick={(e) => {
                  e.stopPropagation();
                  handleLinkClick("overview");
                }}
              className="block text-gray-800 text-lg font-medium hover:text-blue-600 transition text-left"
            >
              Overview
            </button> */}
          </nav> 

          <div className="flex flex-col gap-3 pt-4 text-center">
            <Button
              onClick={() => {
                navigate("/login");
                setIsOpen(false);
              }}
              className="w-full text-center text-gray-800 border border-gray-300 rounded-lg py-2 font-medium hover:bg-gray-50 transition"
            >
              Sign in
            </Button>
            <Button
              onClick={() => {
                navigate("/signup");
                setIsOpen(false);
              }}
              className="w-full text-center bg-[#0088FF] text-white rounded-lg py-2 font-semibold hover:opacity-90 transition"
            >
              Get started
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
